module.exports = {"431027100":"沤江镇","431027101":"沙田镇","431027102":"清泉镇","431027103":"大塘镇","431027104":"四都镇","431027105":"寨前镇","431027106":"普乐镇","431027200":"桥头乡","431027208":"新坊乡","431027210":"东洛乡","431027213":"青山乡","431027400":"宋坪林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431027.json
// module id = 2025
// module chunks = 0